export default __webpack_public_path__ + "static/media/zoom_out.05c424a0.svg";